import _toArray from "@babel/runtime/helpers/toArray";
import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Flex, Stack, Text, xcss } from '@atlaskit/primitives';
import { components } from '@atlaskit/select';
import { CmdbIcon } from './cmdb-icon';
import { BoldMatchingText, createAttributeString, createLabelString, getVisibleAttributes } from './utils';
export var EditDropdownOption = function EditDropdownOption(props) {
  var data = props.data,
    selectProps = props.selectProps,
    filterAttributes = props.filterAttributes;
  var Option = components.Option;

  // return regular select formatting if there is no cmdbObject
  if (!data.cmdbObject) {
    return /*#__PURE__*/React.createElement(Option, props);
  }
  var inputValue = selectProps.inputValue;
  var object = data.cmdbObject;
  var visibleAttributes = getVisibleAttributes(object.attributes, filterAttributes);
  var _visibleAttributes = _toArray(visibleAttributes),
    secondaryAttributes = _visibleAttributes.slice(1);
  var labelAttribute = createLabelString(visibleAttributes, object.label);
  var secondaryAttributesDescription = createAttributeString(secondaryAttributes);
  return /*#__PURE__*/React.createElement(Option, props, /*#__PURE__*/React.createElement(Box, {
    paddingInline: "space.200",
    paddingBlock: "space.100",
    xcss: boxHover
  }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Box, {
    xcss: iconBoxStyle
  }, /*#__PURE__*/React.createElement(CmdbIcon, object.avatar.mediaClientConfig)), /*#__PURE__*/React.createElement(Box, {
    xcss: contentBoxStyle
  }, /*#__PURE__*/React.createElement(Stack, {
    space: "space.025"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "medium"
  }, /*#__PURE__*/React.createElement(BoldMatchingText, {
    match: inputValue !== null && inputValue !== void 0 ? inputValue : ''
  }, labelAttribute)), /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, /*#__PURE__*/React.createElement(BoldMatchingText, {
    match: inputValue !== null && inputValue !== void 0 ? inputValue : '',
    isSmall: true
  }, secondaryAttributesDescription)))))));
};
var boxHover = xcss({
  ':hover': {
    backgroundColor: 'color.background.input.hovered'
  }
});
var iconBoxStyle = xcss({
  marginRight: 'space.150',
  flexShrink: 0
});
var contentBoxStyle = xcss({
  color: 'color.text'
});